import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function Sheet({ organization }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.organization}>
      <div className={styles.row}>
        <div className={styles.group}>
          <h3 className={styles.title}>
            {t("planzoneParametersPage.organization.name")} :
          </h3>
          <p className={styles.text}>{organization.name}</p>
        </div>
        <div className={styles.group}>
          <h3 className={styles.title}>
            {t("planzoneParametersPage.organization.type")} :
          </h3>
          <p className={styles.text}>{organization.type}</p>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.group}>
          <h3 className={styles.title}>
            {t("planzoneParametersPage.organization.mainAddress")} :
          </h3>
          <p className={styles.text}>{organization.principalAddress.street}</p>
          <p className={styles.text}>
            {organization.principalAddress.zipCode}{" "}
            {organization.principalAddress.city}
          </p>
          <p className={styles.text}>{organization.principalAddress.state}</p>
          <p className={styles.text}>{organization.principalAddress.country}</p>
        </div>
        <div className={styles.group} />
      </div>
    </div>
  );
}

export { Sheet };
